module.exports = __webpack_public_path__ + "img/20200512_163053.aea82066.jpg";